import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { MembersGroup } from "../../../types/models/MembersGroup";
import MembersGroupListItem from "../../../../auth/components/membersGroup/MembersGroupList/MembersGroupListItem";
import UserListItem from "../../../../auth/components/user/UserList/UserListItem";
import RoleListItem from "../../../../auth/components/role/RoleList/RoleListItem";
import MembersGroupUserListItem from "../../../../auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem";
import ScopeGroupListItem from "../../../../auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem";
import RoleAssignmentListItem from "../../../../auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: MembersGroup;
};

const MembersGroupTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'membersGroup');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="MembersGroup-tabs"
            >
                { session.hasPermission('', 'applications/auth/entities/MembersGroups/list/view') &&
                    <Tab label={t`Members Groups`} value="membersGroup"/>
                }
                { session.hasPermission('', 'applications/auth/entities/Users/list/view') &&
                    <Tab label={t`Users`} value="user"/>
                }
                { session.hasPermission('', 'applications/auth/entities/Roles/list/view') &&
                    <Tab label={t`Roles`} value="role"/>
                }
                { session.hasPermission('', 'applications/auth/entities/MembersGroupUsers/list/view') &&
                    <Tab label={t`Members Group Users`} value="membersGroupUser"/>
                }
                { session.hasPermission('', 'applications/auth/entities/ScopeGroups/list/view') &&
                    <Tab label={t`Scope Groups`} value="scopeGroup"/>
                }
                { session.hasPermission('', 'applications/auth/entities/RoleAssignments/list/view') &&
                    <Tab label={t`Role Assignments`} value="roleAssignment"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/auth/entities/MembersGroups/list/view') &&
                <TabPanel value={tabValue} index="membersGroup" data-testid="MembersGroup-tab">
                    <MembersGroupListItem membersGroupId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/Users/list/view') &&
                <TabPanel value={tabValue} index="user" data-testid="User-tab">
                    <UserListItem membersGroupId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/Roles/list/view') &&
                <TabPanel value={tabValue} index="role" data-testid="Role-tab">
                    <RoleListItem membersGroupId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/MembersGroupUsers/list/view') &&
                <TabPanel value={tabValue} index="membersGroupUser" data-testid="MembersGroupUser-tab">
                    <MembersGroupUserListItem membersGroupId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/ScopeGroups/list/view') &&
                <TabPanel value={tabValue} index="scopeGroup" data-testid="ScopeGroup-tab">
                    <ScopeGroupListItem membersGroupId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/RoleAssignments/list/view') &&
                <TabPanel value={tabValue} index="roleAssignment" data-testid="RoleAssignment-tab">
                    <RoleAssignmentListItem membersGroupId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default MembersGroupTabs;
